import SettingsIndex from '../../../components/SettingsIndex';

const TemplateSettingsSideIndex = () => (
  <SettingsIndex
    options={[
      { label: 'Email Templates', url: '/template-settings/email-template-settings' },
      { label: 'Submission Templates', url: '/template-settings/submission-template-settings' },
      { label: 'Excel Import Templates', url: '/template-settings/excel-template-settings' },
      { label: 'Download Templates', url: '/template-settings/download-template-settings' },
    ]}
  />
);

export default TemplateSettingsSideIndex;
